import { Cesium } from 'app/cesium';
import { BaseColorRenderer } from 'app/shared/utilities/color_renderer';
import { createCesiumColorForStrOrArrayColor } from 'app/shared/utilities/ims_color';

/**
 * Create a color renderer that takes a color and returns that same color unmodified
 */

export class DirectColorRenderer extends BaseColorRenderer {
    constructor() {
        super();
    }
    default: Cesium.Color = Cesium.Color.WHITE;

    getColor(value) {
        return createCesiumColorForStrOrArrayColor(value);
    }
}
